import { render } from "./SupportFloat.vue?vue&type=template&id=a362dd7c&scoped=true"
import script from "./SupportFloat.vue?vue&type=script&lang=js"
export * from "./SupportFloat.vue?vue&type=script&lang=js"

import "./SupportFloat.vue?vue&type=style&index=0&id=a362dd7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a362dd7c"]])

export default __exports__